import * as React from "react";
const SvgFiRrWomanHead = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-woman-head_svg__a)">
      <path
        fill="#062147"
        d="M14.5 13a1.5 1.5 0 1 1 0-2.999 1.5 1.5 0 0 1 0 2.999m9.425 5.144A5 5 0 0 1 19 24h-4a1 1 0 0 1-1-1v-2.263A8 8 0 0 1 12 21a7.8 7.8 0 0 1-2-.27V23a1 1 0 0 1-1 1H5a5 5 0 0 1-4.925-5.856l.3-1.74a2.94 2.94 0 0 1 5.337-1.138C6.976 17.124 9.409 19 12 19c3.13 0 6.214-2.779 7.13-5.376a1.03 1.03 0 0 1 .959-.667l.432.007A1.46 1.46 0 0 0 22 11.5a1.5 1.5 0 0 0-1.23-1.474 1 1 0 0 1-.816-.879A7.977 7.977 0 0 0 12 2C6.423 2 4.892 5.628 3.662 8.544c-.224.527-.435 1.03-.662 1.483a13.35 13.35 0 0 0 10.186-5.608 1 1 0 1 1 1.628 1.162 15.1 15.1 0 0 1-4.956 4.467 1.5 1.5 0 1 1-1.725.84 15.8 15.8 0 0 1-7.257 1.1A1 1 0 0 1 .5 10.136a6.4 6.4 0 0 0 1.319-2.369C3.124 4.674 5.1 0 12 0a9.97 9.97 0 0 1 9.85 8.274A3.5 3.5 0 0 1 24 11.5a3.43 3.43 0 0 1-.854 2.257c.007.026.025.047.03.075zM8 19.94a11.1 11.1 0 0 1-3.941-3.552.95.95 0 0 0-.783-.424h-.017a.945.945 0 0 0-.911.782l-.3 1.739A3 3 0 0 0 5 22h3zm13.955-1.455-.628-3.613q-.286.068-.579.086A11.03 11.03 0 0 1 16 19.952V22h3a3 3 0 0 0 2.955-3.515"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-woman-head_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWomanHead;
